export default [
 
  {
    title: 'Home Page',
    to: { name: 'root' },
    icon: { icon: 'tabler-smart-home' },
    children: [
      { title: 'Sub-link 1', to: { name: 'root' } },
      { title: 'Sub-link 2', to: {  name: 'root' } },
    ],
  },

  {
    title: 'PBT',
    to: { name: 'utama-pbt' },
    icon: { icon: 'tabler-file' },
  },

  {
    title: 'Ahli PBT',
    to: { name: 'utama-ahli-pbt' },
    icon: { icon: 'tabler-file' },
  },

  {
    title: 'i-Tegur',
    to: { name: 'utama-itegur' },
    icon: { icon: 'tabler-file' },
  },

  {
    title: 'OSC',
    to: { name: 'utama-osc' },
    icon: { icon: 'tabler-file' },
  },

  {
    title: 'Pasar PBT',
    to: { name: 'utama-pasar-pbt' },
    icon: { icon: 'tabler-file' },
  },

  {
    title: 'Home Page Admin',
    to: { name: 'inspektorat' },
    icon: { icon: 'tabler-file' },
  },

  {
    title: 'Inspektorat i-Tegur',
    to: { name: 'inspektorat-itegur' },
    icon: { icon: 'tabler-file' },
  },

  {
    title: 'Inspektorat Ahli PBT',
    to: { name: 'inspektorat-ahli-pbt' },
    icon: { icon: 'tabler-file' },
  },
  
  {
    title: 'Inspektorat Pasar PBT',
    to: { name: 'inspektorat-pasar-pbt' },
    icon: { icon: 'tabler-file' },
  },
  
  {
    title: 'Login',
    to: { name: 'login' },
    icon: { icon: 'tabler-smart-home' },
  },

  // {
  //   title: 'Home',
  //   to: { name: 'root' },
  //   icon: { icon: 'tabler-smart-home' },
  // },
  // {
  //   title: 'Second page',
  //   to: { name: 'second-page' },
  //   icon: { icon: 'tabler-file' },
  // },
]
